import React from 'react';
import StarRow from './StarRow';

const SummaryKpiCards = ({ summary, totalResponses }) => {
  const averageSatisfaction = Number(summary?.averageSatisfaction ?? 0);
  const npsScore = Number(summary?.npsScore ?? 0);
  const positiveRate = Number(summary?.positiveRate ?? 0);
  const promoters = Number(summary?.promoters ?? 0);
  const passives = Number(summary?.passives ?? 0);
  const detractors = Number(summary?.detractors ?? 0);
  const positiveCount = Math.round((positiveRate / 100) * (totalResponses || 0));

  return (
    <div className="fi-kpi-grid">
      <article className="fi-card fi-kpi-card">
        <p className="fi-kpi-label">Avg. Satisfaction</p>
        <p className="fi-kpi-value">
          {averageSatisfaction.toFixed(1)} <span>/ 5</span>
        </p>
        <StarRow value={averageSatisfaction} />
      </article>

      <article className="fi-card fi-kpi-card">
        <p className="fi-kpi-label">NPS Score</p>
        <p className={`fi-kpi-value fi-nps-value${npsScore >= 0 ? ' is-positive' : ' is-negative'}`}>
          {npsScore}
        </p>
        <p className="fi-kpi-meta">
          {promoters} promoters &nbsp;|&nbsp; {passives} passive &nbsp;|&nbsp; {detractors} detractors
        </p>
      </article>

      <article className="fi-card fi-kpi-card">
        <p className="fi-kpi-label">Positive Rate</p>
        <p className="fi-kpi-value">{positiveRate}%</p>
        <p className="fi-kpi-meta">{positiveCount} rated 4 or above</p>
      </article>
    </div>
  );
};

export default SummaryKpiCards;
